/* Nomi Chérie theme: section behaviours. No libraries; sticky + IntersectionObserver + rAF. */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 900px)');
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var headerH = function () { var h = $('.section-header'); return h ? h.offsetHeight : 0; };

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('nm-in'); io.unobserve(e.target); } });
  }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
  function observe(root) { $$('.nm-rv, .nm-mask, .nm-cherry.nm-drop, .nm-name-means li', root).forEach(function (el) { io.observe(el); }); }

  /* hero story */
  var hero, heroState = { idx: -1, timer: null };
  function heroSet(i) {
    if (!hero || i === heroState.idx) return;
    heroState.idx = i;
    var frames = $$('.nm-hero-frame', hero), caps = $$('.nm-hero-cap', hero);
    frames.forEach(function (f, n) { f.classList.toggle('nm-on', n === i); });
    caps.forEach(function (c, n) {
      c.classList.toggle('nm-on', n === i);
      if (!c.nomiHand) return;
      if (n === i) c.nomiHand.play(); else setTimeout(function () { if (heroState.idx !== n) c.nomiHand.reset(); }, 500);
    });
    var b = $('.nm-hero-count b', hero); if (b) b.textContent = '0' + (i + 1);
    var bar = $('.nm-hero-bar', hero); if (bar) bar.style.setProperty('--p', (i + 1) / frames.length);
  }
  function heroLayout() {
    hero = $('.nm-hero');
    clearInterval(heroState.timer);
    if (!hero) return;
    var n = $$('.nm-hero-frame', hero).length;
    if (n < 2) { hero.style.height = ''; return; }
    if (desktop.matches && !REDUCED) {
      hero.style.height = 'calc(100svh - var(--header-height, 70px) + ' + (n - 1) * 32 + 'vh)';
    } else {
      hero.style.height = '';
      if (!REDUCED) heroState.timer = setInterval(function () {
        var r = hero.getBoundingClientRect();
        if (r.bottom > 80 && r.top < innerHeight) heroSet((heroState.idx + 1) % n);
      }, 3400);
    }
  }

  /* what's your nomi: horizontal */
  var occ, occTrack, occSticky, occOver = 0;
  function occLayout() {
    occ = $('.nm-occ'); occOver = 0;
    if (!occ) return;
    occTrack = $('.nm-occ-track', occ); occSticky = $('.nm-occ-sticky', occ);
    occ.style.height = '';
    if (desktop.matches && !REDUCED) {
      occOver = Math.max(0, occTrack.scrollWidth - (innerWidth - $('.nm-occ-intro', occ).offsetWidth));
      occ.style.height = (occSticky.offsetHeight + occOver) + 'px';
    } else occTrack.style.transform = '';
  }

  var ticking = false, par = [];
  function onScroll() {
    ticking = false;
    var hh = headerH();
    if (hero && desktop.matches && !REDUCED) {
      var n = $$('.nm-hero-frame', hero).length, r = hero.getBoundingClientRect();
      var span = r.height - (innerHeight - hh);
      if (n > 1 && span > 0) heroSet(Math.min(n - 1, Math.floor(clamp(-(r.top - hh) / span, 0, 1) * (n - 0.001))));
    }
    if (occ && occOver) {
      var op = clamp(-(occ.getBoundingClientRect().top - hh) / occOver, 0, 1);
      occTrack.style.transform = 'translate3d(' + (-op * occOver).toFixed(1) + 'px,0,0)';
      var pr = $('.nm-occ-progress', occ); if (pr) pr.style.setProperty('--p', op);
    }
    if (desktop.matches && !REDUCED) par.forEach(function (el) {
      var b = el.parentNode.getBoundingClientRect();
      if (b.bottom < -100 || b.top > innerHeight + 100) return;
      el.style.transform = 'translate3d(0,' + ((b.top + b.height / 2 - innerHeight / 2) * parseFloat(el.dataset.parallax)).toFixed(1) + 'px,0) scale(1.1)';
    });
  }
  function boot(root) {
    observe(root); par = $$('[data-parallax]');
    heroState.idx = -1; heroLayout(); occLayout(); heroSet(0); onScroll();
  }
  addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  addEventListener('resize', function () { heroLayout(); occLayout(); onScroll(); });
  addEventListener('load', function () { occLayout(); onScroll(); });
  document.addEventListener('nomi:hand-ready', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { setTimeout(function () { boot(e.target); }, 50); });
  document.addEventListener('shopify:block:select', function (e) {
    var f = e.target.closest('.nm-hero-frame');
    if (f) heroSet($$('.nm-hero-frame', hero).indexOf(f));
    var c = e.target.closest('.nm-occ-card');
    if (c && !occOver) c.scrollIntoView({ inline: 'center', block: 'nearest' });
  });
})();

/* product page: sibling colours (each Nomi colour is its own product, "Bag - Colour") */
(function () {
  function load(box) {
    var family = box.dataset.family, current = box.dataset.current, list = box.querySelector('.nm-colours-list');
    if (!family || !window.routes || box.dataset.loaded) return;
    box.dataset.loaded = '1';
    var url = window.routes.predictive_search_url + '?q=' + encodeURIComponent(family) + '&resources[type]=product&resources[limit]=10&resources[options][fields]=title';
    fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) {
      var items = ((d.resources || {}).results || {}).products || [];
      items.filter(function (p) { return p.title.indexOf(family + ' - ') === 0 && p.handle !== current && p.available !== false; })
        .sort(function (a, b) { return a.title.localeCompare(b.title); })
        .forEach(function (p) {
          var colour = p.title.slice(family.length + 3), a = document.createElement('a');
          a.className = 'nm-swatch'; a.href = p.url.split('?')[0]; a.title = colour;
          var src = (p.featured_image && p.featured_image.url) || p.image;
          if (src) { var img = new Image(); img.alt = colour; img.loading = 'lazy'; img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200&height=250&crop=center'; a.appendChild(img); }
          list.appendChild(a);
        });
      if (list.children.length < 2) box.hidden = true;
      document.dispatchEvent(new CustomEvent('nomi:colours-ready'));
    }).catch(function () {});
  }
  function init(root) { [].slice.call((root || document).querySelectorAll('[data-nomi-colours]')).forEach(load); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* collection pages: endless scrolling. Pagination stays in the HTML for search engines and no-JS; here it is
   replaced by a quiet loader that fetches the next page as the shopper nears the end of the grid. */
(function () {
  var busy = false, io = null;
  function nextLink() { return document.querySelector('#ProductGridContainer .pagination a.pagination__item--prev'); }
  function arm() {
    var wrap = document.querySelector('#ProductGridContainer .pagination-wrapper');
    if (io) { io.disconnect(); io = null; }
    if (!wrap || !('IntersectionObserver' in window)) return;
    wrap.classList.add('nm-endless');
    if (!nextLink()) { wrap.classList.add('nm-endless--done'); return; }
    io = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) more(); }, { rootMargin: '900px 0px' });
    io.observe(wrap);
  }
  function more() {
    var link = nextLink(), grid = document.getElementById('product-grid');
    if (busy || !link || !grid) return;
    busy = true;
    var wrap = document.querySelector('#ProductGridContainer .pagination-wrapper');
    wrap.classList.add('nm-endless--loading');
    fetch(link.href).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var items = doc.querySelectorAll('#product-grid > li'), fresh = doc.querySelector('#ProductGridContainer .pagination-wrapper');
      var start = grid.children.length;
      items.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
      [].slice.call(grid.children, start).forEach(function (li) {
        li.querySelectorAll('.scroll-trigger').forEach(function (el) { el.classList.remove('scroll-trigger--offscreen'); });
        li.classList.remove('scroll-trigger--offscreen');
      });
      if (fresh) wrap.replaceWith(document.importNode(fresh, true)); else wrap.remove();
      busy = false; arm();
    }).catch(function () { busy = false; wrap.classList.remove('nm-endless', 'nm-endless--loading'); if (io) io.disconnect(); });
  }
  function init() {
    var box = document.getElementById('ProductGridContainer');
    if (!box) return;
    arm();
    // Dawn's filters swap the grid's HTML; re-arm when that happens
    new MutationObserver(function () { if (!busy && !document.querySelector('#ProductGridContainer .pagination-wrapper.nm-endless')) arm(); })
      .observe(box, { childList: true, subtree: false });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* product page: sticky add-to-bag bar. It presses the real Dawn button, so variants, errors and the cart drawer all behave the same. */
(function () {
  function init() {
    var info = document.querySelector('product-info'), old = document.querySelector('.nm-buybar');
    if (old) old.remove();
    if (!info) return;
    var btn = info.querySelector('.product-form__submit');
    if (!btn) return;
    var bar = document.createElement('div');
    bar.className = 'nm-buybar';
    bar.innerHTML = '<div class="nm-buybar-in"><img class="nm-buybar-img" alt=""><div class="nm-buybar-txt"><b></b><span></span></div><div class="nm-buybar-colours"></div><button type="button" class="button button--primary nm-buybar-btn"></button></div>';
    document.body.appendChild(bar);
    var img = bar.querySelector('img'), name = bar.querySelector('b'), price = bar.querySelector('.nm-buybar-txt span'), cols = bar.querySelector('.nm-buybar-colours'), go = bar.querySelector('button');
    function sync() {
      var first = info.querySelector('.product__media img'), t = info.querySelector('.product__title h1'), p = info.querySelector('.price .price-item--sale, .price .price-item--regular'), list = info.querySelector('.nm-colours-list');
      if (info.querySelector('.price--on-sale')) p = info.querySelector('.price .price-item--sale') || p;
      if (first) img.src = first.currentSrc || first.src;
      if (t) name.textContent = t.textContent.replace(/\s+/g, ' ').trim();
      if (p) price.textContent = p.textContent.trim();
      if (list && list.children.length > 1) cols.innerHTML = list.innerHTML;
      var pb = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe'); // Shopify's draft-preview bar; sit above it so the bar can be reviewed
      bar.style.bottom = pb ? pb.offsetHeight + 'px' : '';
      go.textContent = (btn.querySelector('span') || btn).textContent.trim();
      go.disabled = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
    }
    go.addEventListener('click', function () { btn.click(); });
    new MutationObserver(sync).observe(btn, { attributes: true, childList: true, subtree: true, characterData: true });
    document.addEventListener('nomi:colours-ready', sync);
    new IntersectionObserver(function (e) {
      var show = !e[0].isIntersecting; // main button off screen, above or below
      if (show) sync();
      bar.classList.toggle('nm-show', show);
    }).observe(btn);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* product image pop-up (Dawn's product-modal): one photo per screen, fitted to the window. Swipe, arrows, arrow keys
   or the mouse wheel change photo; click a photo to zoom in, drag to move around it, click again to zoom out. */
(function () {
  var ZOOM = 2.4;
  function setup(modal) {
    if (modal.nmLightbox) return; modal.nmLightbox = true;
    var track = modal.querySelector('.product-media-modal__content'), dialog = modal.querySelector('.product-media-modal__dialog');
    if (!track || !dialog) return;
    var slides = function () { return [].slice.call(track.children); };
    var z = null, wheelLock = 0;

    dialog.insertAdjacentHTML('beforeend',
      '<button type="button" class="nm-lb-nav nm-lb-prev" aria-label="Previous photo"><span>←</span></button>' +
      '<button type="button" class="nm-lb-nav nm-lb-next" aria-label="Next photo"><span>→</span></button>' +
      '<p class="nm-lb-count" aria-live="polite"></p>');
    var prev = dialog.querySelector('.nm-lb-prev'), next = dialog.querySelector('.nm-lb-next'), count = dialog.querySelector('.nm-lb-count');

    function index() { return Math.round(track.scrollLeft / (track.clientWidth || 1)); }
    function paint() {
      var i = index(), n = slides().length;
      count.textContent = n > 1 ? (i + 1) + ' / ' + n : '';
      prev.hidden = n < 2 || i === 0; next.hidden = n < 2 || i >= n - 1;
    }
    function go(i, instant) {
      unzoom();
      i = Math.min(slides().length - 1, Math.max(0, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
    }

    function apply() { z.img.style.transform = 'translate(' + z.x + 'px,' + z.y + 'px) scale(' + ZOOM + ')'; }
    function limit() {
      var mx = Math.max(0, (z.w * ZOOM - track.clientWidth) / 2 + 40), my = Math.max(0, (z.h * ZOOM - track.clientHeight) / 2 + 40);
      z.x = Math.min(mx, Math.max(-mx, z.x)); z.y = Math.min(my, Math.max(-my, z.y));
    }
    function zoom(img, e) {
      var r = img.getBoundingClientRect(), nw = img.naturalWidth || r.width, nh = img.naturalHeight || r.height;
      var k = Math.min((r.width - parseFloat(getComputedStyle(img).paddingLeft) * 2) / nw, (r.height - parseFloat(getComputedStyle(img).paddingTop) * 2) / nh);
      z = { img: img, w: nw * k, h: nh * k, x: 0, y: 0 };
      z.x = (r.left + r.width / 2 - e.clientX) * (ZOOM - 1); z.y = (r.top + r.height / 2 - e.clientY) * (ZOOM - 1);
      limit(); track.classList.add('nm-lb-zoomed'); img.classList.add('nm-lb-zoom'); apply();
    }
    function unzoom() {
      if (!z) return;
      z.img.classList.remove('nm-lb-zoom', 'nm-lb-drag'); z.img.style.transform = ''; track.classList.remove('nm-lb-zoomed'); z = null;
    }

    var down = null;
    track.addEventListener('pointerdown', function (e) {
      if (e.target.tagName !== 'IMG' || (e.pointerType === 'mouse' && e.button !== 0)) return;
      down = { x: e.clientX, y: e.clientY, ox: z ? z.x : 0, oy: z ? z.y : 0, moved: false, img: e.target };
      if (z) { e.preventDefault(); try { e.target.setPointerCapture(e.pointerId); } catch (err) {} z.img.classList.add('nm-lb-drag'); }
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      if (Math.abs(e.clientX - down.x) + Math.abs(e.clientY - down.y) > 6) down.moved = true;
      if (z) { z.x = down.ox + e.clientX - down.x; z.y = down.oy + e.clientY - down.y; limit(); apply(); }
    });
    function up(e) {
      if (!down) return;
      var d = down; down = null;
      if (z) z.img.classList.remove('nm-lb-drag');
      if (d.moved || e.type === 'pointercancel') return;
      if (z) unzoom(); else zoom(d.img, e);
    }
    track.addEventListener('pointerup', up);
    track.addEventListener('pointercancel', up);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    // Dawn closes this pop-up on any mouse click; here a click zooms, so only the close button and Esc close it
    dialog.addEventListener('pointerup', function (e) { if (!e.target.closest('.product-media-modal__toggle')) e.stopPropagation(); });

    track.addEventListener('wheel', function (e) {
      if (z) { e.preventDefault(); z.x -= e.deltaX; z.y -= e.deltaY; limit(); apply(); return; }
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return; // sideways trackpad swipe: native scroll-snap handles it
      e.preventDefault();
      var now = Date.now();
      if (now < wheelLock || Math.abs(e.deltaY) < 12) return;
      wheelLock = now + 450; go(index() + (e.deltaY > 0 ? 1 : -1));
    }, { passive: false });

    prev.addEventListener('click', function () { go(index() - 1); });
    next.addEventListener('click', function () { go(index() + 1); });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
    window.addEventListener('resize', function () { if (modal.hasAttribute('open')) { unzoom(); paint(); } });

    new MutationObserver(function () {
      unzoom();
      if (!modal.hasAttribute('open')) return;
      window.requestAnimationFrame(function () { // Dawn scrolls to the clicked photo for a stacked layout; re-aim for the sideways one
        var active = track.querySelector('.active'), i = slides().indexOf(active);
        go(i < 0 ? 0 : i, true); paint();
      });
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }
  function init() { [].slice.call(document.querySelectorAll('product-modal')).forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
